module.exports = __webpack_public_path__ + "static/media/testimonial-background.06418fec.jpg";